<template>

  <div class="home">
    <Navbar :is-active="1"></Navbar>
    <div class="body">
      <CommercialSidebar active="productos" />
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Productos / <span>Nuevo producto</span></h2>
        </div>
        <div class="page__subtitle">
          <h3>Información del Producto</h3>
        </div>
        <section class="page__filters">
          <div class="input" style="background: #e7e7e7;">
            <p>Fecha de Registro</p>
            <span>{{ hoy }}</span>
          </div>
          <div class="input" style="background: #e7e7e7;">
            <p>Fecha de Actualización</p>
            <span>-</span>
          </div>
          <div class="input" style="max-height: 62px;">
            <p>SKU del Producto</p>
            <input type="text" v-model="product_code" @keypress="onlynumber(e)" maxlength="10">
          </div>
          <div class="input" style="max-height: 62px;">
            <p>Número de Barcode</p>
            <input type="text" v-model="product_barcode" @keypress="alphanumeric(e)" @keyup="drawBarcode()" maxlength="15">
          </div>
          <!-- <div class="input" style="max-height:62px;">
            <p>Code</p>
            <div style="margin-top: -30px; text-align: right;" class="barcode"></div>
          </div> -->
          <div class="input" style="max-height: 62px;">
            <p>Nombre</p>
            <input type="text" style="max-height: 62px;" v-model="product_name" @keypress="alphanumericWithSpace(e)">
          </div>
          <div class="input" style="max-height: 62px;">
            <p>Tipo de Producto</p>
            <select v-model="product_type_id" @change="search">
              <option selected="selected" value="">Tipo de Producto</option>
              <option v-for="valor of type" :key="valor.name" :value="valor.id">{{ valor.name }}</option>
            </select>
          </div>
          <div class="input" style="max-height: 62px;">
            <p>Marca</p>
            <select v-model="product_brand_id" @change="search">
              <option selected="selected" value="">Marca de Producto</option>
              <option v-for="valor of brand" :key="valor.name" :value="valor.id">{{ valor.name }}</option>
            </select>
          </div>
          <div class="input" style="max-height: 62px;">
            <p>Precio</p>
            <input type="text" style="height: 4rem;" v-model="product_price" @keypress="onlynumber(e)">
          </div>
          <div class="input">
            <p>Descripción del Producto</p>
            <textarea v-model="product_descripcion" rows="4" cols="50" @keypress="alphanumericWithSpace(e)"></textarea>
          </div>
        </section>
        <br>
        <div class="page__subtitle">
          <h3>Imágen del Producto</h3>
        </div>
        <section class="page__product">
          <div class="product__image">
            <img :src="imagen" alt="Subir imagen">
          </div>
          <div class="product__buttons">
            <button>
              <span>Cargar Imagen</span>
              <i class="fas fa-upload"></i>
              <input type="file" id="input_file" value="" @change="change_file" ref="fileupload">
            </button>
            <button @click="deleteImagen()">
              <span>Eliminar Imagen</span>
              <i class="far fa-trash-alt"></i>
            </button>
          </div>
        </section>

        <div class="page__subtitle">
          <h3>Lista de sucursales</h3>
        </div>
        <section class="page__filters"
                 style="border-bottom: 1px solid #938f8f; align-items: center; display: flex; flex-direction: row; justify-content: space-between;">
          <div class="input"
               style="align-items: center; display: flex; flex-direction: row; justify-content: space-between;">
            <input type="text" v-model="search_sucursal" placeholder="Buscar nombre sucursal">
            <i class="fas fa-search"></i>
          </div>
          <div class="lista_productos__buttons">
            <button style="background: #32ba7c;" @click="showModalFron(this)">
              <span>Agregar</span>
              <i class="fas fa-plus-circle"></i>
            </button>

            <!-- vue modal -->
            <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content">
              <h2 style="text-align: center">Lista de sucursales</h2>
              <br>
              <div class="page__filters" style="flex-wrap: nowrap !important;">
                <div class="input">
                  <input
                      type="text"
                      v-model="branch_code"
                      placeholder="Código de Tienda"
                      @keyup="search"
                  />
                </div>
                <div class="input">
                  <input
                      type="text"
                      v-model="branch_nickname"
                      placeholder="Alias"
                      @keyup="search"
                  />
                </div>
                <div class="input" style="    width: 300px !important;">
                  <select v-model="branch_status" @change="search">
                    <option selected="selected" value="">Estado</option>
                    <option value="1">Activado</option>
                    <option value="0">Desactivado</option>
                  </select>
                </div>
              </div>
              <br>
              <div class="page__table">
                <div class="table-headers">
                  <p v-for="{ label } of columns" :key="label">{{ label }}</p>
                  <p>Accion</p>
                </div>
                <div class="table-body">
                  <div v-for="branch of branchoffice" :key="branch.id">
                    <form>
                      <div class="data">
                        <p>{{ branch.branch_code }}
                        </p>
                        <p>{{ branch.branch_name }}</p>
                        <p>{{ branch.branch_nickname }}</p>
                        <p>{{ branch.branch_direction }}</p>
                        <p>{{ branch.branch_reference }}</p>
                        <p><input type="checkbox" :name="'product'+branch.branch_code"
                                  @click="saveSucursal($event, branch)"></p>
                      </div>
                    </form>
                  </div>
                  <div style="text-align: center;" v-if="empty">
                    <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
                  </div>
                </div>
              </div>
              <br>
              <div class="page__pagination">
                <Pagination
                    :data="pagination"
                    v-on:changePage="handleClickInParent"
                />
              </div>
              <br>
              <section class="page__actions">
                <button @click="closeModal">
                  <span>Cancelar</span>
                  <i class="fa fa-times-circle"></i>
                </button>
                <button @click="filterProducto">
                  <span>Guardar</span>
                  <i class="fa fa-circle-check"></i>
                </button>
              </section>
            </vue-final-modal>
            <!-- vue modal -->
          </div>
          <div class="page__table">
            <div class="table-headers">
              <p v-for="{ label } of columns" :key="label">{{ label }}</p>
              <p>Estado</p>
              <p>Acción</p>
            </div>
            <div class="table-body">
              <div v-for="branch of searchAgregado" :key="branch.id">
                <div class="data">
                  <p>{{ branch.branch_code }}</p>
                  <p>{{ branch.branch_name }}</p>
                  <p>{{ branch.branch_nickname }}</p>
                  <p>{{ branch.branch_direction }}</p>
                  <p>{{ branch.branch_reference }}</p>
                  <p>
                  <div class="dropdown-item-special">
                    Activado
                    <input
                        :id="'check_'+branch.id"
                        type="checkbox"
                        :checked="true"
                        class="dropdown-checkbox"
                        @change="changeStatus($event, branch)"
                    />
                    <label class="wrapper" :for="'check_'+branch.id">
                      <span class="circle"></span>
                    </label>
                  </div>
                  </p>
                  <p>
                    <svg @click="deleteSucursal(branch)" xmlns="http://www.w3.org/2000/svg"
                         class="h-1 w-1 button_delete" viewBox="0 0 20 20" fill="red">
                      <path fill-rule="evenodd"
                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                            clip-rule="evenodd"/>
                    </svg>
                  </p>
                </div>
              </div>
              <div style="text-align: center;" v-if="empty_searchAgregado">
                <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
              </div>
            </div>
          </div>
        </section>

        <section class="page__actions">
          <button @click="exitProduct()">
            <span>Cancelar</span>
            <i class="fa fa-times-circle"></i>
          </button>
          <button @click="saveProduct()">
            <span>Guardar</span>
            <i class="fa fa-circle-check"></i>
          </button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import axios from "axios";
import {VueFinalModal} from 'vue-final-modal'
import Pagination from '@/components/Pagination.vue'
import OpenArrow from '@/components/OpenArrow.vue'
import CommercialSidebar from '@/components/CommercialSidebar.vue'

export default {
  name: 'ClientAddProduct',
  components: {
    Navbar,
    VueFinalModal,
    Pagination,
    OpenArrow,
    CommercialSidebar
  },
  data() {
    return {
      type: [],
      brand: [],
      showModal: false,
      empty_searchAgregado: true,
      hoy: new Date().toISOString().slice(0, 10).split('-').reverse().join('-'),
      product_code: '',
      branchoffice: [],
      sucursales_check: [],
      searchAgregado: [],
      pagination: [],
      branchofficeSeleccionados: [],
      columns: [
        {
          label: 'Código de Tienda',
          field: 'branch_code',
          dataFormat: this.codeFormat
        },
        {label: 'Nombre Sucursal', field: 'branch_name'},
        {label: 'Alias', field: 'branch_nickname'},
        {label: 'Dirección', field: 'branch_direction'},
        {label: 'Referencia', field: 'branch_reference'},
      ],
      product_barcode: '',
      product_name: '',
      product_type_id: '',
      product_brand_id: '',
      product_price: '',
      product_discout_bf: '',
      product_discout: '',
      product_descripcion: '',
      search_sucursal: '',
      file: null,
      product_path: "",
      imagen:
          location.protocol +
          "//" +
          location.host +
          "/default/default_product.jpg",
      branch_code: '',
      branch_name: '',
      branch_nickname: '',
      branch_dep_id: '',
      branch_pro_id: '',
      branch_dis_id: '',
      branch_status: '',
      role: localStorage.getItem('role'),
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/login')
    }
    this.company_name = localStorage.getItem('company_name');
    this.getTypeBrand()
  },
  computed: {
    searchAgregado: function () {
      let listado = this.searchAgregado.filter((item) =>
          item.branch_name
              .toLowerCase()
              .includes(this.search_sucursal.toLowerCase())
      );
      this.empty_searchAgregado = (listado.length === 0)
      return listado
    },
  },
  methods: {
    barcode() {
      let self = this
      function toSetC(text) {
        return text.match(/\d{2}/g).map((ascii, index) => {
          var codeC = Number(ascii);
          var charCode = codeC > 94 ? codeC + 100 : codeC + 32;
          return String.fromCharCode(charCode)
        }).join('');
      }
      function checkSum128(data, startCode) {
        var sum = startCode;
        for (var i = 0; i < data.length; i++) {
          var code = data.charCodeAt(i);
          var value = code > 199 ? code - 100 : code - 32;
          sum += (i + 1) * (value);
        }

        var checksum = (sum % 103) + 32;
        if (checksum > 126) checksum = checksum + 68;
        return String.fromCharCode(checksum);
      }
      function encodeToCode128(text, codeABC = "B") {
        var startCode = String.fromCharCode(codeABC.toUpperCase().charCodeAt() + 138);
        var stop = String.fromCharCode(206);

        text = codeABC == 'C' && toSetC(text) || text;

        var check = checkSum128(text, startCode.charCodeAt(0) - 100);

        text = text.replace(" ", String.fromCharCode(194));

        return startCode + text + check + stop;
      }
      function renderBarcodes() {
        var barcodeElements = document.querySelector(".barcode");
        var code = self.product_barcode
        barcodeElements.innerHTML = encodeToCode128(code);
      }
      renderBarcodes();
    },
    drawBarcode(){
      if (this.product_barcode.length >= 2){
        this.barcode();
      }else{
        var barcodeElements = document.querySelector(".barcode");
        barcodeElements.innerHTML = '';
      }
    },
    onlynumber(evt) {
      evt = (evt) ? evt : window.event
      const charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    alphanumeric(evt) {
      evt = (evt) ? evt : window.event
      const charCode = (evt.which) ? evt.which : evt.keyCode
      if (
          (charCode >= 65 && charCode <= 90) ||   // Letras mayúsculas (A-Z)
          (charCode >= 97 && charCode <= 122) ||  // Letras minúsculas (a-z)
          (charCode >= 48 && charCode <= 57)      // Números (0-9)
      ) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    alphanumericWithSpace(evt) {
      evt = (evt) ? evt : window.event
      const charCode = (evt.which) ? evt.which : evt.keyCode

      if (
          (charCode >= 65 && charCode <= 90) ||   // Letras mayúsculas (A-Z)
          (charCode >= 97 && charCode <= 122) ||  // Letras minúsculas (a-z)
          (charCode >= 48 && charCode <= 57) ||   // Números (0-9)
          charCode === 32  // Espacio
      ) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    backCompany() {
      this.$router.push('/comercial')
    },
    async getTypeBrand() {
      await axios.get('general/elements/type', {
        params: {
          product_company_id: localStorage.getItem('company_id')
        }
      }).then(res => {
        this.type = res.data.data
      })
      await axios.get('general/elements/brand', {
        params: {
          product_company_id: localStorage.getItem('company_id')
        }
      }).then(res => {
        this.brand = res.data.data
      })
    },

    deleteSucursal(id) {
      this.sucursales_check = this.sucursales_check.filter((item) => item !== id)

      for (var i = 0; i < this.searchAgregado.length; i++) {
        if (this.searchAgregado[i].id === id.id) {
          this.searchAgregado.splice(i, 1);
        }
      }
      if (this.searchAgregado.length === 0) {
        this.empty_searchAgregado = true
      }
    },
    changeStatus(e, id) {
      let activado = (e.target.checked) ? 1 : 0
      this.searchAgregado.filter((item, key) => {
        if (item === id) {
          this.searchAgregado[key].product_status = activado
        }
      })
    },
    saveSucursal(event, id) {
      if (event.target.checked) {
        this.sucursales_check.push(id)
      } else {
        this.sucursales_check = this.sucursales_check.filter((item) => item !== id)
      }
    },
    handleClickInParent: function (page) {
      this.getall(page)
    },
    search: function () {
      clearTimeout(this.timeout);
      var self = this;
      this.timeout = setTimeout(function () {
        console.log(self)
        let paramSearch = {
          branch_code: self.branch_code,
          branch_nickname: self.branch_nickname,
          nombre_producto: self.nombre_producto,
          branch_pro_id: self.branch_pro_id,
          branch_dis_id: self.branch_dis_id,
          branch_dep_id: self.branch_dep_id,
          branch_status: self.branch_status,
        }
        this.getall(1, paramSearch)
      }.bind(this), 500);
    },
    filterProducto() {
      if (this.sucursales_check) {
        this.sucursales_check.forEach(item => {
          this.searchAgregado.push(item)
        })
      }
      this.sucursales_check = this.sucursales_check.filter((item) => item === 'clear')
      this.showModal = false;
      if (this.searchAgregado.length !== 0) {
        this.empty_searchAgregado = false
      }
    },
    async getall(page = 1, paramSearch = {}) {
      var tempProduct = ''
      this.searchAgregado.forEach((item, index) => {
        if (index === 0) {
          tempProduct = item.id.toString()
        } else {
          tempProduct = tempProduct + ',' + item.id.toString()
        }
      })
      await axios.get('general/branchoffice', {
        params: {
          page: page,
          not: (tempProduct) ? tempProduct : null,
          branch_company_id: localStorage.getItem('company_id'),
          branch_code: paramSearch.branch_code,
          branch_nickname: paramSearch.branch_nickname,
          branch_dep_id: paramSearch.branch_dep_id,
          branch_dis_id: paramSearch.branch_dis_id,
          branch_pro_id: paramSearch.branch_pro_id,
          branch_status: paramSearch.branch_status,
        }, headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }).then(res => {
        if (res.data.data.total > 0) {
          this.branchoffice = res.data.data.data
          this.branchoffice.forEach(item => {
            item.checked = false
          })
          this.branchoffice_export = res.data.export
          this.pagination = res.data.data
          this.empty = false
        } else {
          this.branchoffice = {}
          this.pagination = {}
          this.empty = true
        }
      })
    },
    closeModal() {
      this.showModal = false
    },
    showModalFron(chkbox) {
      this.getall()
      // for (var i=0;i < document.forms[0].elements.length;i++)
      // {
      //   var elemento = document.forms[0].elements[i];
      //   if (elemento.type === "checkbox")
      //   {
      //     elemento.checked = chkbox.checked
      //   }
      // }
      setTimeout(() => {
        this.showModal = true;
      }, 100)
    },
    change_file(event) {
      if (typeof event.target.files[0] !== "undefined") {
        this.file = event.target.files[0];
        console.log(this.file);
        let reader = new FileReader();
        if (
            event.target.files[0].type === "image/png" ||
            event.target.files[0].type === "image/jpeg" ||
            event.target.files[0].type === "image/jpg"
        ) {
          reader.onload = (e) => {
            this.imagen = e.target.result;
          };
        } else {
          this.$swal({
            position: "top-end",
            icon: "error",
            title: "El archivo no es un formato de imagen",
            showConfirmButton: false,
            timer: 2000,
          });
        }
        reader.readAsDataURL(this.file);
      }
    },
    deleteImagen() {
      this.$refs.fileupload.value = null;
      this.imagen =
          location.protocol +
          "//" +
          location.host +
          "/default/default_product.jpg";
    },
    async saveProduct() {

      try {
        var request_product_code = parseInt(this.product_code);
        var request_product_barcode = parseInt(this.product_barcode);
        var request_product_name = this.product_name;
        var request_product_type_id = this.product_type_id;
        var request_product_brand_id = this.product_brand_id;
        var request_product_price = this.product_price;
        var request_product_discout_bf = this.product_discout_bf;
        var request_product_discout = this.product_discout;
        var request_product_descripcion = this.product_descripcion;
        var request_product_company_id = localStorage.getItem("company_id");
        var tempSucursal = "";
        this.searchAgregado.forEach((item, index) => {
          if (index === 0) {
            tempSucursal = item.id.toString() + ':' + item.product_status;
          } else {
            tempSucursal = tempSucursal + "," + item.id.toString() + ':' + item.product_status;
          }
        });
        const formData = new FormData();
        formData.append("file", this.file);
        formData.append("product_code", request_product_code);
        formData.append("product_barcode", request_product_barcode);
        formData.append("product_name", request_product_name);
        formData.append("product_type_id", request_product_type_id);
        formData.append("product_brand_id", request_product_brand_id);
        formData.append("product_price", request_product_price);
        formData.append("product_discout_bf", request_product_discout_bf);
        formData.append("product_discout", request_product_discout);
        formData.append("product_descripcion", request_product_descripcion);
        formData.append("product_company_id", request_product_company_id);
        formData.append("product_company_id", request_product_company_id);
        formData.append("sucursales", tempSucursal);

        console.log(formData);
        const response = await axios.post('general/product', formData);
        // const response = await axios.post('general/product', {
        //   product_code: this.product_code,
        //   product_barcode: this.product_barcode,
        //   product_name: this.product_name,
        //   product_type_id: this.product_type_id,
        //   product_brand_id: this.product_brand_id,
        //   product_price: this.product_price,
        //   product_discout_bf: this.product_discout_bf,
        //   product_discout: this.product_discout,
        //   product_descripcion: this.product_descripcion,
        //   product_company_id: 1,
        //   sucursales: tempSucursal
        // }, formData)
        if (response.status === 200) {
          this.$swal({
            position: 'center',
            icon: 'success',
            title: 'Producto creado correctamente',
            showConfirmButton: false,
            timer: 2000
          })
          this.$router.push('/products')
          console.log(formData);
        }
      } catch (error) {
        console.log(error)
        this.$swal({
          position: 'center',
          icon: 'error',
          title: 'Completar los datos correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    exitProduct() {
      this.$router.push('/products')
    }
  },
}


</script>


<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  height: 100%;
  overflow-y: auto;
}

.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}

.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}

.modal__action {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 1rem 0 0;
}

.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

#input_file {
  cursor: pointer;
  margin: 0;
  opacity: 0;
  outline: 0 none;
  padding: 0;
  position: absolute;
}

/*------NAVBAR------*/
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
}

.home .navbar {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
}

.home .navbar__left {
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .navbar__left img {
  width: 130px;
}

.home .navbar__center {
  width: 70%;
  height: 100%;
}

.home .navbar__center ul {
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
  display: flex;
  justify-content: flex-start;
}

.home .navbar__center ul li {
  text-decoration: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
}

.home .navbar__center ul li::before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 0;
  height: 4px;
  background-color: #ff3128;
  transition: .3s ease;
}

.home .navbar__center ul li:hover {
  color: #ff3128;
}

.home .navbar__center ul li:hover::before {
  width: 100%;
}

.home .navbar__right {
  display: flex;
  width: 20%;
}

.home .navbar__right .profile {
  display: flex;
  width: 100%;
  height: 100%;
}

.home .navbar__right .profile__detail {
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
}

.home .navbar__right .profile__detail p {
  margin: 0;
}

.home .navbar__right .profile__detail span {
  color: #938f8f;
  font-weight: 300;

}

.home .navbar__right .profile__icon,
.home .navbar__right .profile__logout {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #ff3128;
  cursor: pointer;
}

/*------NAVBAR------*/

/*-------------------------*/
a:hover {
  text-decoration: none;
}

/*-------------------------*/

/*------BODY------*/

.body {
  width: 100%;
  height: 600px;
  display: flex;
}

.body__containt {
  height: calc(100vh - 120px);
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}

.body__sidebar {
  width: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.body__sidebar .floating-icon {
  position: absolute;
  right: -15px;
  top: 30px;
  color: #ff3128;
  font-size: 30px;
}

.body__sidebar .title {
  width: 100%;
  height: 140px;
  border-bottom: 1px solid #b6b6b6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.body__sidebar .title__icon {
  color: #ff3128;
  font-size: 20px;
}

.body__sidebar .title__text {
  margin: 0 10px;

}

.body__sidebar .title__text h2 {
  font-size: 20px;
  margin: 0;
}

.body__sidebar .title__text p {
  margin: 0;
  font-weight: 300;
}

.body__sidebar .tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 140px);
  padding-top: 5px;
}

.body__sidebar .tabs .tab {
  width: 90%;
  height: 70px;
  border-radius: 10px;
  color: #707070;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.3 ease;
}

.body__sidebar .tabs .tab:hover,
.body__sidebar .tabs .tab.active {
  color: #ff3128;
  background: #ffeeed;
}

.body__sidebar .tabs .tab__icon {
  font-size: 20px;
  margin-right: 10px;
}

.body__sidebar .tabs .tab__text p {
  margin: 0;
  font-weight: 600;
}

/*----------------------------*/
/*----------------------------*/
/*----------------------------*/
.body__containt {
  height: fit-content;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  overflow-y: scroll;
}

.body__containt .page__subtitle,
.body__containt .page__title {
  width: 100%;
  margin-bottom: 20px;
}

.body__containt .page__title h2 {
  font-weight: 600;
  color: #000;
  font-size: 25px;
}

.body__containt .page__title h2 span {
  color: #ff3128;
}

.body__containt .page__subtitle h3 {
  color: #ff3128;
  font-weight: 600;
  font-size: 20px;
}

/*-----FILTERS------*/

.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
}

.body__containt .page__filters .input {
  width: 300px;
  border-radius: 10px;
  border: 1px solid #938f8f;
  display: flex;
  flex-direction: column;
  padding: 7px 15px;
  transition: 0.4s ease;

}

.body__containt .page__filters .input:hover {
  box-shadow: 10px 15px 15px rgba(0, 0, 0, 0.05);
}

.body__containt .page__filters .input:nth-child(2) {

}

.body__containt .page__filters .input:nth-last-child(1) {
  width: 1260px;
}

.body__containt .page__filters .input span {
  font-size: 15px;
  color: #938f8f;
}

.body__containt .page__filters .input p {
  margin: 0;
}

.page__filters input, select, textarea {
  outline: none;
  border: none;
  background: white;
}

/*-----PRODUCT------*/
.page__product {
  width: 100%;
  display: flex;
}

.page__product .product__image,
.page__product .product__buttons {
  /* width: 50%; */
  display: flex;
  align-items: center;
}

.page__product .product__image {
  width: 400px;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
}

.page__product .product__image img {
  width: 100%;
  object-fit: cover;
  transition: 1s ease;
}

.page__product .product__image img:hover {
  transform: scale(1.1) rotate(1deg);
}

.page__product .product__buttons {
  width: 500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.page__actions button,
.page__product .product__buttons button {
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
}

.page__actions button:hover,
.page__product .product__buttons button:hover {
  transform: scale(1.1);
}

.page__actions button:nth-child(2),
.page__product .product__buttons button:nth-child(1) {
  background: #32ba7c;
}

.page__product .product__buttons button:nth-child(2) {
  background: #262626;
}

.page__product .product__buttons button:hover:nth-child(2) {
  background: #ff3128;
}

/*------------------------*/
/*------------------------*/
/*------------------------*/

.page__actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px 0;
  gap: 20px;
}

.page__actions button:nth-child(1) {
  background: #ff3128;
}

/*------BODY------*/
/*TABLA*/
.body__containt .page__table {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
}

.body__containt .page__table .table-headers {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-evenly;
  border-bottom: 1px solid #b6b6b6;
}

.body__containt .page__table .table-headers p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  white-space: nowrap;
}

.body__containt .page__table .table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.body__containt .page__table .table-body .data {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}

.body__containt .page__table .table-body .data p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  margin: 10px 0;
}

.body__containt .page__table .table-body .data p:nth-child(1) {
  color: #ff3128;
}

.lista_productos__buttons button {
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
}

.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 17px;
  left: 2px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32ba7c;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.dropdown-checkbox {
  display: none;
}

.dropdown-checkbox:checked + .wrapper {
  background-color: #32ba7c;
}

.dropdown-checkbox:checked + .wrapper > .circle {
  left: 15px;
}

.wrapper {
  width: 31px;
  height: 16px;
  cursor: pointer;
  margin-bottom: 0;
  margin-left: 1rem;
  position: relative;
  border-radius: 30px;
  background-color: #cbcbcb;
}

.circle {
  left: 0;
  width: 15px;
  height: 15px;
  transition: 0.2s;
  position: absolute;
  border-radius: 50%;
  background-color: #fff;
}

.button_delete {
  width: 2rem;
}

.body__sidebar.open {
  display: none;
}

/*check*/
input[type="checkbox"] {
  width: 100%;
  height: 20px;
}

/*dropdown*/
.dropdown {
  display: flex;
  margin: 10px 0;
  font-weight: 300;
  position: relative;
  align-items: center;
  width: calc(100% / 7);
  justify-content: center;
}

.button {
  background: none;
  border: 0;
  color: inherit;
  outline: none;
}

.dropdown-item {
  height: 50px;
  display: flex;
  cursor: pointer;
  align-items: center;
}

.dropdown-item:active {
  color: inherit;
  background-color: inherit;
}

.dropdown-item svg {
  color: red;
  font-size: 1.2rem;
  margin-right: 0.8rem;
}

.dropdown-item-special {
  height: 60px;
  display: flex;
  padding: 1rem;
  font-weight: 400;
  align-items: center;
  justify-content: flex-end;
}

.dropdown-checkbox {
  display: none;
}

.dropdown-checkbox:checked + .wrapper {
  background-color: #32ba7c;
}

.dropdown-checkbox:checked + .wrapper > .circle {
  left: 15px;
}

.wrapper {
  width: 31px;
  height: 16px;
  cursor: pointer;
  margin-bottom: 0;
  margin-left: 1rem;
  position: relative;
  border-radius: 30px;
  background-color: #cbcbcb;
}

.circle {
  left: 0;
  width: 15px;
  height: 15px;
  transition: 0.2s;
  position: absolute;
  border-radius: 50%;
  background-color: #fff;
}

.back_company {
  background: #000;
  color: white;
  width: 100%;
  padding-top: 3%;
  padding-left: 10%;
}

.barcode {
  font-family: "Libre Barcode 128", "Courier New", Courier, monospace;
  font-weight: normal;
  font-size: 52px;
  white-space: nowrap;
}
</style>
